/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Translation } from '../../models/translation';

export interface TranslationsControllerFindTranslationForAppByIdentifierLanguageCodeKey$Params {

/**
 * The app id
 */
  appIdentifier: string;

/**
 * The language code
 */
  languageCode: string;

/**
 * The key
 */
  key: string;
}

export function translationsControllerFindTranslationForAppByIdentifierLanguageCodeKey(http: HttpClient, rootUrl: string, params: TranslationsControllerFindTranslationForAppByIdentifierLanguageCodeKey$Params, context?: HttpContext): Observable<StrictHttpResponse<Translation>> {
  const rb = new RequestBuilder(rootUrl, translationsControllerFindTranslationForAppByIdentifierLanguageCodeKey.PATH, 'get');
  if (params) {
    rb.path('appIdentifier', params.appIdentifier, {});
    rb.path('languageCode', params.languageCode, {});
    rb.path('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Translation>;
    })
  );
}

translationsControllerFindTranslationForAppByIdentifierLanguageCodeKey.PATH = '/translations/app/{appIdentifier}/language/{languageCode}/key/{key}';
